module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/d41c524271bef5df3c70c47f1fcefca2.png";